import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import CustomTextArea from "../../../../components/common/CustomTextArea/CustomTextArea";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import CustomRadio from "../../../../components/common/CustomRadio/CustomRadio";
import BodyHeader from "../../../../components/common/CommonBodyHeader";

import { useNavigate, useParams } from "react-router-dom";
import {
   fetchAllContractorsAsync,
   fetchSingleDriveMasterAsync,
   updateDriverMasterAsync,
} from "../../../../redux/features/driverMaster";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import validation from "../../../../helpers/validation";
import useFocusErrorField from "../../../../Hooks/useFocusErrorField";
import { YRS_OF_EXPERIENCE_DATA } from "../../../../constansts/Options";

const validationSchema = Yup.object().shape({
   name: Yup.string().required("Name is required"),
   mobile: Yup.string()
      .matches(/^\d{10}$/, "Mobile number must be 10 digits")
      .required("Mobile number is required"),
   dob: Yup.string()
      .required("DOB is required")
      .test("is-past", "Date must be in the past", function (value) {
         // Parse the date string using Moment.js and check if it's in the past
         const date = moment(value, "YYYY-MM-DD");
         return date.isValid() && date.isBefore(moment(), "years");
      }),

   joiningDate: Yup.string()
      .required("Date of Joining is required")
      .test("is-before-2999", "Date must be before 31-12-2999", function (value) {
         const date = moment(value, "YYYY-MM-DD");
         return date.isValid() && date.isBefore(moment("2999-12-31"), "years");
      }),
   exitDate: Yup.string()
      .notRequired()
      .test("is-before-2999", "Date must be before 31-12-2999", function (value) {
         // Parse the date string using Moment.js and check if it's in the past
         if (!value) return true;
         const date = moment(value, "YYYY-MM-DD");
         return date.isValid() && date.isBefore(moment("2999-12-31"), "years");
      }),
   expofyears: Yup.string().required("Expierence is required"),
   address: Yup.string().required("Address is required"),
   drivingLicense: Yup.string().required("Name is required"),
   licenseExp: Yup.string().required("Date Of Birth is required"),
   aadharCard: Yup.string()
      .required("Aadhar Number is required")
      .matches(/^[2-9]{1}[0-9]{11}$/, "Invalid aadhar card no!"),
   panCard: Yup.string().matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invaid pan card no!"),

   payRollType: Yup.string().required("Payroll Type is required"),

   contractorName: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Contractor",
      then: () => Yup.string().required("Contractor Name is required"),
      otherwise: () => Yup.string().notRequired(),
   }),
   monthlyCommAmount: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Contractor",
      then: () => validation.amount("monthly commission"),
      otherwise: () => validation.amount("monthly commission", false),
   }),

   // accountNumber: validation.accountNumber(),
   // bankName: validation.bankName(),
   // ifscCode: validation.ifscCode(),
   // accountHolderName: validation.name("account holder name"),
   // monthlyAmount: validation.amount("monthly salary"),

   accountNumber: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Eisaku Pay Roll",
      then: () => validation.accountNumber(),
      otherwise: () => validation.accountNumber(false),
   }),
   bankName: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Eisaku Pay Roll",
      then: () => validation.bankName(),
      otherwise: () => validation.bankName(false),
   }),
   ifscCode: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Eisaku Pay Roll",
      then: () => validation.ifscCode(),
      otherwise: () => validation.ifscCode(false),
   }),
   accountHolderName: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Eisaku Pay Roll",
      then: () => validation.name("account holder name"),
      otherwise: () => validation.name("account holder name", false),
   }),
   monthlyAmount: Yup.string().when("payRollType", {
      is: (payRollType) => payRollType === "Eisaku Pay Roll",
      then: () => validation.amount("monthly salary amount"),
      otherwise: () => validation.amount("monthly salary amount", false),
   }),

   // for driver
   driverAccountNumber: validation.accountNumber(false),
   driverBankName: validation.bankName(false),
   driverIfscCode: validation.ifscCode(false),
   driverAccountHolderName: validation.name("account holder name", false),
   driverMonthlyAmount: validation.amount("monthly salary", false),
});
const initialValues = {
   name: "",
   mobile: "",
   dob: "",
   joiningDate: "",
   exitDate: "",
   expofyears: "",
   driverImage: "",
   address: "",

   drivingLicense: "",
   licenseExp: "",
   dlUpload: "",

   aadharCard: "",
   aadharCardImg: "",
   panCard: "",
   panCardImg: "",

   payRollType: "",

   contractorName: "",
   monthlyCommAmount: "",

   accountNumber: "",
   bankName: "",
   ifscCode: "",
   accountHolderName: "",
   monthlyAmount: "",

   // for driver
   driverAccountNumber: "",
   driverBankName: "",
   driverIfscCode: "",
   driverAccountHolderName: "",
   driverMonthlyAmount: "",
};

export default function DriverMasterEdit() {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const params = useParams();

   const driverMaster = useSelector((state) => state.driverMaster);
   const singleDriverMaster = driverMaster?.singleDriverMaster;
   const contractorsData = driverMaster?.contractors?.map?.((item) => ({
      label: item?.name,
      value: item?.id,
   }));

   const handleUpdateDriver = (formData) => {
      dispatch(backdropLoadingAction(true));
      const data = {
         id: params?.id,

         name: formData.name,
         mobile: formData.mobile,
         dob: formData.dob,
         doj: formData.joiningDate,
         doe: formData.exitDate,
         experience: formData.expofyears,
         driver_image: formData.driverImage,
         address: formData.address,

         driver_license: formData.drivingLicense,
         license_expiry_date: formData.licenseExp,
         dl_document: formData.dlUpload,

         aadhar_card: formData.aadharCard,
         aadhar_card_doc: formData.aadharCardImg,

         pan_card: formData.panCard,
         pan_card_doc: formData.panCardImg,

         payroll: formData.payRollType,

         model_id: 4,
         action_id: 2,
         _method: "PATCH",
      };

      if (data.payroll === "Eisaku Pay Roll") {
         data.account_number = formData.accountNumber;
         data.bank_name = formData.bankName;
         data.ifsc_code = formData.ifscCode;
         data.account_holder_name = formData.accountHolderName;
         data.monthly_salary_amount = formData.monthlyAmount;
      } else if (data.payroll === "Contractor") {
         data.contractor_master_id = formData.contractorName;
         data.driver_account_number = formData.driverAccountNumber;
         data.driver_bank_name = formData.driverBankName;
         data.driver_ifsc_code = formData.driverIfscCode;
         data.driver_account_holder_name = formData.driverAccountHolderName;
         data.driver_monthly_salary_amount = formData.driverMonthlyAmount;
         data.monthly_salary_commission_amount = formData?.monthlyCommAmount;
      }

      if (typeof data.aadhar_card_doc === "string") {
         delete data.aadhar_card_doc;
      }
      if (typeof data.pan_card_doc === "string") {
         delete data.pan_card_doc;
      }
      if (typeof data.driver_image === "string") {
         delete data.driver_image;
      }
      if (typeof data.dl_document === "string") {
         delete data.dl_document;
      }

      if (!data.pan_card) {
         delete data.pan_card;
         delete data.pan_card_doc;
      }
      if (!data.aadhar_card) {
         delete data.aadhar_card;
         delete data.aadhar_card_doc;
      }

      const newData = new FormData();
      Object.keys(data).forEach((key) => {
         newData.append(key, data[key]);
      });

      dispatch(
         updateDriverMasterAsync({
            data: newData,
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               toast.error(error);
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Updated successfully.");
               dispatch(
                  fetchSingleDriveMasterAsync({
                     id: params.id,
                  })
               );
            },
         })
      );
   };

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(fetchAllContractorsAsync({}));
      dispatch(
         fetchSingleDriveMasterAsync({
            id: params.id,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
         })
      );
   }, []);

   useEffect(() => {
      if (singleDriverMaster) {
         setValues((prev) => {
            return {
               name: singleDriverMaster?.name,
               mobile: singleDriverMaster?.mobile,
               dob: singleDriverMaster?.dob,
               joiningDate: singleDriverMaster?.doj,
               exitDate: singleDriverMaster?.doe ? singleDriverMaster.doe : "",
               expofyears: singleDriverMaster?.experience,
               driverImage: singleDriverMaster?.driver_image,
               address: singleDriverMaster?.address,

               drivingLicense: singleDriverMaster?.driver_license,
               licenseExp: singleDriverMaster?.license_expiry_date,
               dlUpload: singleDriverMaster?.dl_document,

               aadharCard: singleDriverMaster?.aadhar_card,
               aadharCardImg: singleDriverMaster?.aadhar_card_doc,
               panCard: singleDriverMaster?.pan_card ? singleDriverMaster?.pan_card : "",
               panCardImg: singleDriverMaster?.pan_card_doc,

               payRollType: singleDriverMaster?.payroll,

               accountNumber: singleDriverMaster?.account_number,
               bankName: singleDriverMaster?.bank_name,
               ifscCode: singleDriverMaster?.ifsc_code,
               accountHolderName: singleDriverMaster?.account_holder_name,
               monthlyAmount: singleDriverMaster?.monthly_salary_amount,

               driverAccountNumber: singleDriverMaster?.driver_account_number,
               driverBankName: singleDriverMaster?.driver_bank_name,
               driverIfscCode: singleDriverMaster?.driver_ifsc_code,
               driverAccountHolderName: singleDriverMaster?.driver_account_holder_name,
               driverMonthlyAmount: singleDriverMaster?.driver_monthly_salary_amount,
               contractorName: singleDriverMaster?.contractor_master_id,
               monthlyCommAmount: singleDriverMaster?.monthly_salary_commission_amount,
            };
         });
      }
   }, [singleDriverMaster]);

   const formik = useFormik({
      initialValues,
      validationSchema,
      enableReinitialize: true,
      onSubmit: (values) => handleUpdateDriver(values),
   });

   const {
      errors,
      touched,
      values,
      isSubmitting,
      handleSubmit,
      setFieldValue,
      setValues,
      getFieldProps,
      resetForm,
   } = formik;

   // Focus error field
   useFocusErrorField(errors, isSubmitting);

  

   return (
      <div>
         <BodyHeader title="Edit Driver Master" />
         <form className="p-3 shadow-lg">
            <div className="card card-primary">
               <div className="card-header">
                  <h3 className="card-title">Personal Details</h3>
               </div>
               <div className="card-body">
                  <div className="row">
                     <div className="col-lg-3">
                        <CustomInput
                           require
                           label="Name"
                           id="driverName"
                           placeholder="Enter Name"
                           {...getFieldProps("name")}
                           errors={touched.name && errors?.name}
                           message={errors?.name}
                        />
                     </div>

                     <div className="col-lg-3">
                        <CustomInput
                           require
                           label="Mobile No"
                           id="mobile"
                           placeholder="Enter Mobile No"
                           {...getFieldProps("mobile")}
                           errors={Boolean(touched.mobile) && Boolean(errors.mobile)}
                           message={errors.mobile}
                        />
                     </div>

                     <div className="col-lg-3">
                        <CustomDatePicker
                           require
                           label="DOB"
                           name="dob"
                           id="dob"
                           placeholder="Select DOB"
                           {...getFieldProps("dob")}
                           errors={touched.dob && errors?.dob}
                           message={errors?.dob}
                        />
                     </div>

                     {/* Date of Joining */}
                     <div className="col-lg-3">
                        <CustomDatePicker
                           require
                           label="Date of Joining"
                           placeholder="Select Date of Joining"
                           id="joiningDate"
                           name="joiningDate"
                           {...getFieldProps("joiningDate")}
                           errors={touched.joiningDate && errors?.joiningDate}
                           message={errors?.joiningDate}
                        />
                     </div>

                     {/* Date of Exit */}
                     <div className="col-lg-4">
                        <CustomDatePicker
                           label="Date of Exit"
                           placeholder="Select Date of Exit"
                           id="exitDate"
                           name="exitDate"
                           {...getFieldProps("exitDate")}
                           errors={touched.exitDate && errors?.exitDate}
                           message={errors?.exitDate}
                        />
                     </div>

                     {/* Expierence (Years) */}
                     <div className="col-lg-4">
                        <CustomDropdown
                           require
                           optionData={YRS_OF_EXPERIENCE_DATA}
                           label="Experience (Years)"
                           placeholder="Select Experience (Years)"
                           id="expofyears"
                           name="expofyears"
                           {...getFieldProps("expofyears")}
                           onChange={(values) => {
                              setFieldValue("expofyears", values?.[0]?.value);
                           }}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomFileUpload
                           label="Driver Image"
                           id="driverImage"
                           name="driverImage"
                           {...getFieldProps("driverImage")}
                           onChange={(e) =>
                              setFieldValue("driverImage", e.target.files[0])
                           }
                           errors={touched.driverImage && errors?.driverImage}
                           message={errors?.driverImage}
                        />
                     </div>

                     <div className="col-lg-12">
                        <CustomTextArea
                           label="Address"
                           id="address"
                           name="address"
                           placeholder="Enter Address"
                           {...getFieldProps("address")}
                           errors={touched.address && errors?.address}
                           message={errors?.address}
                        />
                     </div>
                  </div>
               </div>
            </div>

            <div className="card card-primary">
               <div className="card-body">
                  <div className="row">
                     {/* Driver License */}
                     <div className="col-lg-4">
                        <CustomInput
                           require
                           label="Driver License"
                           id="driverLicense"
                           placeholder="Enter Driver License"
                           name="drivingLicense"
                           {...getFieldProps("drivingLicense")}
                           errors={touched.drivingLicense && errors?.drivingLicense}
                           message={errors?.drivingLicense}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomDatePicker
                           require
                           label="License Expiry details"
                           placeholder="Select Expiry details"
                           id="licenseExp"
                           name="licenseExp"
                           {...getFieldProps("licenseExp")}
                           errors={touched.licenseExp && errors?.licenseExp}
                           message={errors?.licenseExp}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomFileUpload
                           label="DL Document"
                           id="dlUpload"
                           name="dlUpload"
                           {...getFieldProps("dlUpload")}
                           onChange={(e) => setFieldValue("dlUpload", e.target.files[0])}
                           errors={touched.dlUpload && errors?.dlUpload}
                           message={errors?.dlUpload}
                        />
                     </div>
                  </div>
               </div>
            </div>

            <div className="card card-primary">
               <div className="card-header">
                  <h3 className="card-title">Identification Documents</h3>
               </div>
               <div className="card-body">
                  <div className="row">
                     <div className="col-lg-6">
                        <CustomInput
                           require
                           label="Aadhar Card"
                           id="aadharCard"
                           placeholder="Enter Aadhar Card"
                           name="aadharCard"
                           {...getFieldProps("aadharCard")}
                           errors={touched.aadharCard && errors?.aadharCard}
                           message={errors?.aadharCard}
                        />
                     </div>

                     <div className="col-lg-6">
                        <CustomFileUpload
                           label="Aadhar card"
                           name="aadharCardImg"
                           {...getFieldProps("aadharCardImg")}
                           onChange={(e) =>
                              setFieldValue("aadharCardImg", e.target.files[0])
                           }
                           errors={touched.aadharCardImg && errors?.aadharCardImg}
                           message={errors?.aadharCardImg}
                        />
                     </div>

                     <div className="col-lg-6">
                        <CustomInput
                           label="Pan Card"
                           id="panCard"
                           placeholder="Enter Pan Card"
                           name="panCard"
                           {...getFieldProps("panCard")}
                           errors={touched.panCard && errors?.panCard}
                           message={errors?.panCard}
                        />
                     </div>

                     <div className="col-lg-6">
                        <CustomFileUpload
                           label="Pan Card"
                           name="panCardImg"
                           {...getFieldProps("panCardImg")}
                           onChange={(e) =>
                              setFieldValue("panCardImg", e.target.files[0])
                           }
                           errors={touched.panCardImg && errors?.panCardImg}
                           message={errors?.panCardImg}
                        />
                     </div>
                  </div>
               </div>
            </div>

            {/* Pay roll Sec */}
            <div className="card card-primary">
               <div className="card-header">
                  <h3 className="card-title">Pay roll</h3>
               </div>

               <div className="card-body">
                  <div className="form-group">
                     <CustomRadio
                        label="Eisaku Pay Roll"
                        id="eisakuPayRoll"
                        value="Eisaku Pay Roll"
                        name="payRollType"
                        defaultChecked={formik.values?.payRollType === "Eisaku Pay Roll"}
                        checked={formik.values?.payRollType === "Eisaku Pay Roll"}
                        onChange={(e) => setFieldValue("payRollType", e.target.value)}
                     />
                     <CustomRadio
                        label="Contractor"
                        id="contractor"
                        value="Contractor"
                        name="payRollType"
                        checked={formik.values.payRollType === "Contractor"}
                        onChange={(e) => setFieldValue("payRollType", e.target.value)}
                     />
                  </div>

                  {formik.values.payRollType === "Contractor" && (
                     <div className="row">
                        <div className="col-lg-6">
                           <CustomDropdown
                              require
                              label="Contractor Name"
                              id="contractorName"
                              optionData={contractorsData}
                              placeholder="Enter contractor Name"
                              name="contractorName"
                              values={contractorsData?.filter(
                                 (item) => item.value === values?.contractorName
                              )}
                              onChange={(values) => {
                                 setFieldValue("contractorName", values?.[0]?.value);
                              }}
                              errors={touched.contractorName && errors.contractorName}
                              message={errors.contractorName}
                           />
                        </div>
                        <div className="col-lg-6">
                           <CustomInput
                              require
                              label="Monthly Salary & Commission Amount"
                              id="monthlyCommAmount"
                              placeholder="Enter monthly commission amount"
                              {...getFieldProps("monthlyCommAmount")}
                              errors={
                                 touched.monthlyCommAmount && errors?.monthlyCommAmount
                              }
                              message={errors?.monthlyCommAmount}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomInput
                              label="Account Number"
                              id="driverAccountNumber"
                              placeholder="Enter Account Number"
                              {...getFieldProps("driverAccountNumber")}
                              errors={
                                 touched.driverAccountNumber &&
                                 errors?.driverAccountNumber
                              }
                              message={errors?.driverAccountNumber}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomInput
                              label="Bank name"
                              id="driverBankName"
                              placeholder="Enter Bank Name"
                              name="driverBankName"
                              {...getFieldProps("driverBankName")}
                              errors={touched.driverBankName && errors?.driverBankName}
                              message={errors?.driverBankName}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomInput
                              label="IFSC Code"
                              id="driverIfscCode"
                              placeholder="Enter IFSC Code"
                              {...getFieldProps("driverIfscCode")}
                              errors={touched.driverIfscCode && errors?.driverIfscCode}
                              message={errors?.driverIfscCode}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              label="Account Holder Name"
                              id="driverAccountHolderName"
                              placeholder="Enter Account Holder name"
                              {...getFieldProps("driverAccountHolderName")}
                              errors={
                                 touched.driverAccountHolderName &&
                                 errors?.driverAccountHolderName
                              }
                              message={errors?.driverAccountHolderName}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomInput
                              label="Monthly salary amount"
                              id="driverMonthlyAmount"
                              placeholder="Enter Monthly salary amount"
                              {...getFieldProps("driverMonthlyAmount")}
                              errors={
                                 touched.driverMonthlyAmount &&
                                 errors?.driverMonthlyAmount
                              }
                              message={errors?.driverMonthlyAmount}
                           />
                        </div>
                     </div>
                  )}

                  {formik.values.payRollType === "Eisaku Pay Roll" && (
                     <div className="row">
                        <div className="col-lg-4">
                           <CustomInput
                              require={values.payRollType === "Eisaku Pay Roll"}
                              label="Account Number"
                              id="accountNumber"
                              placeholder="Enter Account Number"
                              name="accountNumber"
                              {...getFieldProps("accountNumber")}
                              errors={touched.accountNumber && errors?.accountNumber}
                              message={errors?.accountNumber}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomInput
                              require={values.payRollType === "Eisaku Pay Roll"}
                              label="Bank name"
                              id="bankName"
                              placeholder="Enter Bank Name"
                              name="bankName"
                              {...getFieldProps("bankName")}
                              errors={touched.bankName && errors?.bankName}
                              message={errors?.bankName}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomInput
                              require={values.payRollType === "Eisaku Pay Roll"}
                              label="IFSC Code"
                              id="ifscCode"
                              placeholder="Enter IFSC Code"
                              name="ifscCode"
                              {...getFieldProps("ifscCode")}
                              errors={touched.ifscCode && errors?.ifscCode}
                              message={errors?.ifscCode}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              require={values.payRollType === "Eisaku Pay Roll"}
                              label="Account Holder Name"
                              id="accountHolderName"
                              placeholder="Enter Account Holder name"
                              name="accountHolderName"
                              {...getFieldProps("accountHolderName")}
                              errors={
                                 touched.accountHolderName && errors?.accountHolderName
                              }
                              message={errors?.accountHolderName}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomInput
                              require={values.payRollType === "Eisaku Pay Roll"}
                              label="Monthly salary amount"
                              id="monthlyAmount"
                              placeholder="Enter Monthly salary amount"
                              name="monthlyAmount"
                              {...getFieldProps("monthlyAmount")}
                              errors={touched.monthlyAmount && errors?.monthlyAmount}
                              message={errors?.monthlyAmount}
                           />
                        </div>
                     </div>
                  )}
               </div>
            </div>
            <div className="col-12 mt-4 text-center">
               <button
                  className="btn btn-primary px-4 py-3"
                  type="button"
                  onClick={handleSubmit}
               >
                  <h6 className="mb-0 text-uppercase">Submit</h6>
               </button>
            </div>
         </form>
      </div>
   );
}
